// src/components/Admin/OffersAndBanners/OffersAndBanners.js

import React, { useEffect, useState } from "react";
import BannerList from "./BannerList";
import CreateBannerModal from "./CreateBannerModal";
import config from "../../../../config";
import "./Banners.css";

export default function OffersAndBanners() {
  const [activeTab, setActiveTab] = useState("banners");

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingBanner, setEditingBanner] = useState(null);

  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* =========================
     FETCH ALL BANNERS
     ========================= */

  const fetchBanners = async () => {
    setLoading(true);
    setError("");

    try {
      const res = await fetch(`${config.baseUrl}/admin/banners`);

      if (!res.ok) {
        throw new Error("Failed to fetch banners");
      }

      const data = await res.json();

      setBanners(data || []);
    } catch (err) {
      console.error(err);

      setError("Unable to load banners.");

      setBanners([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "banners") {
      fetchBanners();
    }
  }, [activeTab]);

  /* =========================
     ACTIVATE / DEACTIVATE
     ========================= */

  const toggleBannerActive = async (banner) => {
    const action = banner.active ? "disable" : "activate";

    try {
      const res = await fetch(
        `${config.baseUrl}/admin/banners/${banner.id}/${action}`,
        {
          method: "PATCH",
        }
      );

      if (!res.ok) {
        throw new Error("Unable to update banner");
      }

      fetchBanners();
    } catch (err) {
      console.error(err);

      alert("Failed to update banner status.");
    }
  };

  /* =========================
     DELETE
     ========================= */

  const deleteBanner = async (banner) => {
    const confirmed = window.confirm(
      `Delete banner "${banner.title}" ?`
    );

    if (!confirmed) return;

    try {
      const res = await fetch(
        `${config.baseUrl}/admin/banners/${banner.id}`,
        {
          method: "DELETE",
        }
      );

      if (!res.ok) {
        throw new Error("Delete failed");
      }

      fetchBanners();
    } catch (err) {
      console.error(err);

      alert("Unable to delete banner.");
    }
  };

  /* =========================
     CREATE
     ========================= */

  const openCreateBanner = () => {
    setEditingBanner(null);
    setShowCreateModal(true);
  };

  /* =========================
     EDIT
     ========================= */

  const editBanner = (banner) => {
    setEditingBanner(banner);
    setShowCreateModal(true);
  };

  return (
    <div className="offers-banners-page">

      {/* ================= HEADER ================= */}

      <div className="page-header">

        <div>

          <h2>Marketing Banners</h2>

          <p className="page-subtitle">
            Create, manage and schedule promotional banners displayed across the Aurakart app.
          </p>

        </div>

        {activeTab === "banners" && (

          <button
            className="btn-primary"
            onClick={openCreateBanner}
          >
            + Create Banner
          </button>

        )}

      </div>

      {/* ================= TABS ================= */}

      <div className="tabs">

        <button
          className={`tab ${
            activeTab === "banners" ? "active" : ""
          }`}
          onClick={() => setActiveTab("banners")}
        >
          🖼️ Banners ({banners.length})
        </button>

        <button
          className={`tab ${
            activeTab === "offers" ? "active" : ""
          }`}
          onClick={() => setActiveTab("offers")}
        >
          🏷️ Offers
        </button>

      </div>

      {/* ================= CONTENT ================= */}

      <div className="tab-content">

        {activeTab === "banners" && (

          <>

            {loading && (

              <div className="loading-state">

                Loading banners...

              </div>

            )}

            {!loading && error && (

              <div className="error-message">

                {error}

              </div>

            )}

            {!loading && !error && (

              <BannerList
                banners={banners}
                onEdit={editBanner}
                onToggleActive={toggleBannerActive}
                onDelete={deleteBanner}
              />

            )}

          </>

        )}

        {activeTab === "offers" && (

          <div className="coming-soon">

            <h3>🚧 Offers Module Coming Soon</h3>

            <ul>
              <li>Coupon Codes</li>
              <li>Category Offers</li>
              <li>Seller Offers</li>
              <li>Buy X Get Y</li>
              <li>Cashback Offers</li>
              <li>Free Shipping Campaigns</li>
            </ul>

          </div>

        )}

      </div>

      {/* ================= MODAL ================= */}

      {showCreateModal && (

        <CreateBannerModal
          initialData={editingBanner}
          onClose={() => {
            setShowCreateModal(false);
            setEditingBanner(null);
          }}
          onSuccess={() => {
            setShowCreateModal(false);
            setEditingBanner(null);
            fetchBanners();
          }}
        />

      )}

    </div>
  );
}